import React from 'react';
import CourseEditor from '../components/CourseEditor/CourseEditor.js';

const CourseEditorPage = () => {
  return <CourseEditor />;
};

export default CourseEditorPage;